module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAAT5JREFUSEvtlt1Rw0AMhL+tADqAEqADqICkglACVEBSAaECQgVABdBBKCF0QCoQs8ZmMsHKGQZn8hDN+OHudLeSrJ8VQERMgRFw6HWLXEuyzg+JiCvgNrn3AUwlTRQRl8A98A4skgtjSa8J0AAwWJscA0fAuYHGwE21SB5LHiluR8QZ8AJUHu2BiiFrFHYrdBFxAhx0Nv9LcSnpreTRaaMUEU7Zx1+CNOpDSU91fdrYeZN1LtKBpNmKJd7LaqOE7wJ1oVZSF/RMpVv/db49oIhwyNwm+pSFO4N/3EWfKMDz9kLXsyffzzt0TuWRpLu19N40nzL7nNYPrem90r17L9jWMVG3oGziph51aUH7wVdM2N2aR0VzOyise9TQLVOtjG5NNtAtMx2zqDYx3fI3rFpQTSANmE3UvxLIZU0gx5/6Vuneky6bcAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/vip_ico02.png
// module id = dyYl
// module chunks = 11